import * as React from 'react';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import {Button} from 'reactstrap';
import validate from './validate';
import renderTextField from '../../../theme/components/form/Input';

class IngresoForm extends React.PureComponent<InjectedFormProps> {

    public render() {
        const {handleSubmit} = this.props;

        return (
            <form className='material-form' onSubmit={handleSubmit}>
                <div>
                    <Field
                        name='usuario'
                        component={renderTextField}
                        type='text'
                        label='Usuario'
                    />
                </div>
                <div>
                    <Field
                        name='password'
                        component={renderTextField}
                        type='password'
                        label='Contraseña'
                    />
                </div>
                <Button className='btn btn-primary account__btn account__btn' color='primary'
                        type='submit'>INGRESAR</Button>
            </form>
        )
    }
}

export default reduxForm({
    form: 'ingreso_form', // a unique identifier for this form
    validate,
})(IngresoForm);



// WEBPACK FOOTER //
// ./src/components/pages/ingreso/ingreso-form.tsx